<h2 mat-dialog-title>Cabeçalho da Tabela</h2>

<mat-dialog-content fxLayout="column">
    <div style="padding-bottom: 0.5rem">
        <div fxLayout="row" fxFlexFill style="padding: 10px 10px 0 0;">
            <mat-form-field fxFlexOffset="20px" fxFlex="100">
                <input matInput maxlength="1000"
                       name="descricaoCabecalho_{{cabecalho.posicaoLinha}}_{{pinRandom}}"
                       placeholder="Descrição"
                       [(ngModel)]="cabecalho.descricao" required>
            </mat-form-field>
        </div>

        <div fxLayout="row" fxFlexFill style="padding: 10px 10px 0 0;">
            <mat-form-field fxFlexOffset="20px" fxFlex="20">
                <mat-label>Alinhamento</mat-label>
                <mat-select [(ngModel)]="cabecalho.alinhamento" required
                            name="alinhamento_{{cabecalho.posicaoLinha}}_{{pinRandom}}" (selectionChange)="onChangeAlinhamento()">
                    <mat-option></mat-option>
                    <mat-option [value]="'L'"> Esquerda</mat-option>
                    <mat-option [value]="'C'"> Centro</mat-option>
                    <mat-option [value]="'R'"> Direita</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field fxFlexOffset="20px" fxFlex="20">
                <mat-label>Cor do Fundo</mat-label>
                <mat-select [(ngModel)]="cabecalho.corFundoCabecalho" required
                            name="corCabecalho_{{cabecalho.posicaoLinha}}_{{pinRandom}}">
                    <mat-option [value]="'#FFFFFF'">
                        <div style="display: flex; align-items: center;">
                            <div style="margin-right: 5px; width: 20px; height: 20px; background-color: #FFFFFF; border: 1px solid black;"></div>
                            Branco
                        </div>
                    </mat-option>
                    <mat-option [value]="'#9DC4E6'">
                        <div style="display: flex; align-items: center;">
                            <div style="margin-right: 5px; width: 20px; height: 20px; background-color: #9DC4E6; border: 1px solid black;"></div>
                            Azul
                        </div>
                    </mat-option>
                    <mat-option [value]="'#DCE6F1'">
                        <div style="display: flex; align-items: center;">
                            <div style="margin-right: 5px; width: 20px; height: 20px; background-color: #DCE6F1; border: 1px solid black;"></div>
                            Azul Claro
                        </div>
                    </mat-option>
                    <mat-option [value]="'#C7E0B5'">
                        <div style="display: flex; align-items: center;">
                            <div style="margin-right: 5px; width: 20px; height: 20px; background-color: #C7E0B5; border: 1px solid black;"></div>
                            Verde
                        </div>
                    </mat-option>
                    <mat-option [value]="'#808080'">
                        <div style="display: flex; align-items: center;">
                            <div style="margin-right: 5px; width: 20px; height: 20px; background-color: #808080; border: 1px solid black;"></div>
                            Cinza
                        </div>
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <div style="margin-left: 26px;" fxFlex="20">
                <mat-checkbox color="primary" title="Negrito"
                              name="cabecalhoBold_{{pinRandom}}"
                              [(ngModel)]="cabecalho.bold" style="margin-top: 15px">
                    Negrito
                </mat-checkbox>
            </div>

            <div style="margin-left: 26px;" fxFlex="20">
                <mat-checkbox color="primary" title="Italico"
                              name="cabecalhoBold_{{pinRandom}}"
                              [(ngModel)]="cabecalho.italic" style="margin-top: 15px">
                    Italico
                </mat-checkbox>
            </div>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="16px">
    <button mat-button (click)="voltar()">Voltar</button>
</mat-dialog-actions>